import React from 'react';
import './ImageLinkForm.css';


const ImageLinkForm =({onInputChange, onSubmitDetect}) => {
	return (
		<div>
			<p className="f3">
			{"This Magic Brain will detect faces in your images. Give it a try."}
			</p>
		<div className='center'>
			<div className='form center pa4 br3 shadow-5'>
			<input className='f4 pa2 w-70 center' type ='text' onChange={onInputChange}/>
			<button 
			className='w-30 grow f4 link pv2 dib white bg-light-purple pointer'
			onClick={onSubmitDetect}
			> Detect </button>
			</div>
		</div>
		</div>

		);
}

export default ImageLinkForm;